import { useState } from 'react';
import '../Products/Products.scss'
import Card from "./components/Card/Card";
import FilterSelect from './components/FilterSelect';
import FilterRange from './components/FilterRange';
import FilterSearch from './components/FilterSearch/FilterSearch';

const Products = ({products,addToCart,removeFromCart,cart,favourite,addToFavourite,removeFromFavourite, gadgetType, onChangeSelect}) =>{


const [priceMinMax,setPriceMinMax] = useState([0,3000])
const [searchResult, setSearchResult] = useState('')



const  handlePriceChange =(event, newValues) => {
    setPriceMinMax(newValues);
  }
const handleSearch = (event)=>{
    setSearchResult(event.target.value)
}
  const filteredProducts = products.filter(card => {
    
        const isCardInCart = cart.includes(card);
        const isCardInFavourite = favourite.includes(card);
       


    if (gadgetType === 'all devices') {
        return true;
    } else {
        return card.type === gadgetType;
    }
    
}).filter(card => {
    const isCardInCart = cart.includes(card);
    const isCardInFavourite = favourite.includes(card);

    return card.price > priceMinMax[0] && card.price <= priceMinMax[1];
}).filter((card) => {
    const isCardInCart = cart.includes(card);
    const isCardInFavourite = favourite.includes(card);

    return (
      card.title.toLowerCase().includes(searchResult.toLowerCase())
    )
  })
.map(card => {
    const isCardInCart = cart.includes(card);
    const isCardInFavourite = favourite.includes(card);
   
    
    
    return <Card 
        addToCart={addToCart}
        removeFromCart = {removeFromCart}  
        cart={cart} 
        product ={card}
        isCardInCart = {isCardInCart}
        key={card.id}
        favourite= {favourite}
        addToFavourite = {addToFavourite}
        removeFromFavourite = {removeFromFavourite}
        isCardInFavourite = {isCardInFavourite}
    />;
   
})
console.log(gadgetType);

return(
    <>
    <div className="products">
                <div className='products__title-wrapper'>
                    <h2 className="products__title">PRODUCTS CURRENTLY ON SALE</h2>
                </div>
                <div className='products__filter-wrapper'>
                    <FilterSelect onChange={()=>{onChangeSelect()}} gadgetType={gadgetType}/>
                    <div className='products__filter-range'>
                        <FilterRange priceMinMax={priceMinMax} onChange={handlePriceChange}/>
                    </div>
                    <FilterSearch onChange={handleSearch}/>
                </div>
                
                <div className="products__container">
                    
                    <div className="products__wrap">
                        
                        {filteredProducts}
                        
                    </div>
                    
                </div>
                
                
            </div>
        
    </>
)
}
export default Products;